<template>
  <span class="print-view">
    <div class="btn-group text-center my-1">
        <vs-button class="mx-1" type="filled" @click="onClickPrint">Print & Download</vs-button>
    </div>
    <page id="printDiv" size="A4">
      <vx-card-custom style="border-radius: 0" :noShadow="true" :title="`${orderDetails.work_order_code}`">
        <vs-table :noDataText="''" class="__table-heading-small table-dark-inverted table-auto vs-con-loading__container">

        <template slot="thead">
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr>
            <vs-th>Work order code</vs-th>
            <vs-td>{{ orderDetails.work_order_code }}</vs-td>
            <vs-th>Work order date</vs-th>
            <vs-td>{{ orderDetails.work_order_date }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th>Work order start time</vs-th>
            <vs-td>{{ orderDetails.start_time }}</vs-td>
            <vs-th>Work order start time</vs-th>
            <vs-td>{{ orderDetails.end_time }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th>Status</vs-th>
            <vs-td>{{ orderDetails.status.name }}</vs-td>
            <vs-th>ITS product code</vs-th>
            <vs-td>{{ orderDetails.formulation_code }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th>ITS product name</vs-th>
            <vs-td>{{ orderDetails.formulation_name }}</vs-td>
            <!-- <vs-th v-if="orderDetails.required_by">Required by</vs-th>
            <vs-td v-if="orderDetails.required_by">{{ orderDetails.required_by }}</vs-td> -->
          </vs-tr>
          <vs-tr>
            <vs-th>Manufacturing <br> quantity (KG) </vs-th>
            <vs-td>{{ totalQuantityToManufacture }}</vs-td>
            <vs-th></vs-th>
            <vs-td></vs-td>
          </vs-tr>
        </template>
      </vs-table>
      </vx-card-custom>
      <vx-card-custom style="border-radius: 0" :noShadow="true" title="Production line">
        <vs-table :noDataText="''" class="__table-heading-small table-dark-inverted table-auto vs-con-loading__container">

        <template slot="thead">
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr>
            <vs-th>Line code</vs-th>
            <vs-td>{{ orderDetails.production_line_id.production_line_code || '' }}</vs-td>
            <vs-th>Line name</vs-th>
            <vs-td>{{ orderDetails.production_line_id.production_line_name || '' }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th>Type</vs-th>
            <vs-td>{{ orderDetails.production_line_id.type || '' }}</vs-td>
            <vs-th>Clean time</vs-th>
            <vs-td>{{ orderDetails.production_line_id.clean_time_between_uses || '' }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th>Max capacity (L)	</vs-th>
            <vs-td>{{toFixed(orderDetails.production_line_id.max_capacity_ltr) || ''}}</vs-td>
            <vs-th>Max Capacity (KG)	</vs-th>
            <vs-td>{{toFixed(orderDetails.production_line_id.max_capacity_kg) || ''}}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      </vx-card-custom>
      <vx-card-custom style="border-radius: 0" :noShadow="true" title="Sales order"
                      v-if="orderDetails.order_items.length > 0">
        <vs-table class="table-dark-inverted table-auto vs-con-loading__container" :hoverFlat="true"  noDataText="">

                    <template slot="thead">
                      <vs-th>Product Order Code</vs-th>
                      <vs-th>Required By</vs-th>
                      <vs-th>Quantity (KG)</vs-th>
                    </template>

                    <template>
                      <vs-tr :key="index" v-for="(tr, index) in orderDetails.order_items">
                        <vs-td>
                          {{tr.order_code}}
                        </vs-td>
                        <vs-td>
                          {{ tr.required_by || 'N/A' }}
                        </vs-td>
                        <vs-td>
                          {{toFixed(tr.quantity)}}
                        </vs-td>
                      </vs-tr>
                      <vs-tr class="font-semibold">
                        <vs-td>Total</vs-td>
                        <vs-td></vs-td>
                        <vs-td>{{totalSelectedQuantityKilo}}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
      </vx-card-custom>
      <vx-card-custom style="border-radius: 0" :noShadow="true" title="Items">
        <vs-table :hoverFlat="true"  noDataText="" class="table-dark-inverted">
          <template slot="thead">
                      <vs-th class="text-xs" width="5%">ORDER</vs-th>
                      <vs-th class="text-xs" width="25%">ITS PRODUCT CODE</vs-th>
                      <vs-th class="text-xs" width="25%">ITS PRODUCT NAME</vs-th>
                      <vs-th class="text-xs" width="15%">TYPE</vs-th>
                      <vs-th class="text-xs" width="15%">DISSOLVABLE</vs-th>
                      <vs-th class="text-xs" width="15%">PHYSICAL STATE</vs-th>
          </template>
           <template>
                      <vs-tr :key="index" v-for="(tr, index) in wo_formulations">
                        <vs-td colspan="6" v-if="tr.row_type === 'sub'">
                          <vs-table :hoverFlat="true"  noDataText="" class="table-dark-inverted mx-16 my-2">
                            <template slot="thead">
                                <vs-th class="text-xs" width="10%">BATCH NUMBER</vs-th>
                                <vs-th class="text-xs" width="10%">QTY (KG)</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="index_item" v-for="(tr_rm_item, index_item) in tr.items">

                                  <vs-td class="text-xs">
                                    {{ tr_rm_item.batch_no }}
                                  </vs-td>

                                  <vs-td class="text-xs">
                                    {{ tr_rm_item.quantity }}
                                  </vs-td>

                                </vs-tr>
                            </template>
                          </vs-table>
                        </vs-td>
                        <vs-td v-if="tr.row_type === 'main'">
                          {{ tr.manufacture_order }}
                        </vs-td>
                        <vs-td v-if="tr.row_type === 'main'" class="text-xs font-semibold">
                          <span v-if="tr.company_product_code">{{tr.category}}-{{tr.company_product_code}}</span>
                          <span v-if="tr.formulation_code">{{ tr.formulation_code }}</span>
                        </vs-td>
                        <vs-td v-if="tr.row_type === 'main'" class="text-xs">
                          {{ tr.company_product_name || '' }}
                        </vs-td>
                        <vs-td v-if="tr.row_type === 'main'" class="text-xs"> {{ tr.type || '' }} </vs-td>
                        <vs-td v-if="tr.row_type === 'main'" class="text-xs"> {{ tr.dissolvable || '' }} </vs-td>
                        <vs-td v-if="tr.row_type === 'main'" class="text-xs"> {{ tr.physical_state || '' }} </vs-td>

                      </vs-tr>
           </template>
        </vs-table>
      </vx-card-custom>

<!--      <vx-card-custom style="border-radius: 0" :noShadow="true" title="Items">-->
<!--        <vs-table :hoverFlat="true"  noDataText="" class="table-dark-inverted">-->

<!--                    <template slot="thead">-->
<!--                      <vs-th class="text-xs" width="5%">ORDER</vs-th>-->
<!--                      <vs-th class="text-xs">ITS PRODUCT CODE</vs-th>-->
<!--                      <vs-th class="text-xs">ITS PRODUCT NAME</vs-th>-->
<!--                      <vs-th class="text-xs">TYPE</vs-th>-->
<!--                      <vs-th class="text-xs">DISSOLVABLE</vs-th>-->
<!--                      <vs-th class="text-xs">PHYSICAL STATE</vs-th>-->
<!--                    </template>-->

<!--                    <template>-->
<!--                      <vs-tr :key="index" v-for="(tr, index) in orderDetails.formulation">-->
<!--                        <vs-td class="text-xs">-->
<!--                          {{ tr.manufacture_order }}-->
<!--                        </vs-td>-->
<!--                        <vs-td class="text-xs font-semibold">-->
<!--                          <span v-if="tr.company_product_code">{{tr.category}}-{{tr.company_product_code}}</span>-->
<!--                          <span v-if="tr.formulation_code">{{ tr.formulation_code }}</span>-->
<!--                        </vs-td>-->

<!--                        <vs-td class="text-xs">-->
<!--                          {{ tr.company_product_name || '' }}-->
<!--                        </vs-td>-->

<!--                        <vs-td class="text-xs"> {{ tr.type || '' }} </vs-td>-->
<!--                        <vs-td class="text-xs"> {{ tr.dissolvable || '' }} </vs-td>-->
<!--                        <vs-td class="text-xs"> {{ tr.physical_state || '' }} </vs-td>-->

<!--                        <template class="expand-user" slot="expand">-->
<!--                          <div class="con-expand-users w-4/5">-->
<!--                            <vs-table v-if="tr.assigned_raw_material.length > 0" :data="tr.assigned_raw_material">-->

<!--                              <template slot="thead">-->
<!--                                <vs-th class="text-xs" width="10%">BATCH NUMBER</vs-th>-->
<!--                                <vs-th class="text-xs" width="10%">QTY (KG)</vs-th>-->
<!--                              </template>-->

<!--                              <template slot-scope="{data}">-->
<!--                                <vs-tr :key="index_item" v-for="(tr_rm_item, index_item) in data">-->

<!--                                  <vs-td class="text-xs">-->
<!--                                    {{ tr_rm_item.batch_no }}-->
<!--                                  </vs-td>-->

<!--                                  <vs-td class="text-xs">-->
<!--                                    {{ tr_rm_item.quantity }}-->
<!--                                  </vs-td>-->

<!--                                </vs-tr>-->
<!--                              </template>-->

<!--                            </vs-table>-->
<!--                            <vs-table v-if="tr.assigned_raw_material.length === 0" :data="tr.location">-->

<!--                              <template slot="thead">-->
<!--                                <vs-th class="text-xs" width="10%">BATCH NUMBER</vs-th>-->
<!--                                <vs-th class="text-xs" width="10%">QTY (KG)</vs-th>-->
<!--                              </template>-->

<!--                              <template slot-scope="{data}">-->
<!--                                <vs-tr :key="index_item" v-for="(tr_rm_item, index_item) in data">-->

<!--                                  <vs-td class="text-xs">-->
<!--                                    {{ tr_rm_item.batch_no }}-->
<!--                                  </vs-td>-->

<!--                                  <vs-td class="text-xs">-->
<!--                                    {{ tr_rm_item.quantity }}-->
<!--                                  </vs-td>-->

<!--                                </vs-tr>-->
<!--                              </template>-->

<!--                            </vs-table>-->
<!--                          </div>-->
<!--                        </template>-->

<!--                      </vs-tr>-->
<!--                      &lt;!&ndash;                      <vs-tr>&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <vs-td></vs-td>&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <vs-td></vs-td>&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <vs-td></vs-td>&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <vs-td></vs-td>&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <vs-td></vs-td>&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <vs-td></vs-td>&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <vs-td class="font-semibold">Total</vs-td>&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <vs-td class="font-semibold">{{totalRmQuantityKilo}}</vs-td>&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <vs-td class="font-semibold">{{totalRmQuantityLiter}}</vs-td>&ndash;&gt;-->
<!--                      &lt;!&ndash;                      </vs-tr>&ndash;&gt;-->
<!--                    </template>-->
<!--                  </vs-table>-->
<!--      </vx-card-custom>-->

      <vx-card-custom style="border-radius: 0" :noShadow="true" title="QC tests">
        <vs-table
          :data="qc_tests"
          class="table-dark-inverted table-auto vs-con-loading__container">

            <template slot="thead">
              <vs-th width="15%" class="text-xs">DATE</vs-th>
              <vs-th width="15%" class="text-xs">DONE BY</vs-th>
              <vs-th width="10%" class="text-xs">NOTE</vs-th>
              <vs-th width="10%" class="text-xs">STATUS</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].created_at">
                  {{ __dateTimeFormatter(data[indextr].created_at) }}
                </vs-td>

                <vs-td :data="data[indextr].done_by">
                  {{ data[indextr].done_by }}
                </vs-td>

                <vs-td :data="data[indextr].notes">
                  {{ data[indextr].notes }}
                </vs-td>
                <vs-td :data="data[indextr].status">
                  {{ data[indextr].status }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
      </vx-card-custom>
      <vx-card-custom v-if="orderDetails.ccp_items.length > 0" style="border-radius: 0"
                      :noShadow="true" title="CCP items">
        <vs-table :hoverFlat="true"  noDataText="" class="table-dark-inverted table-auto vs-con-loading__container">
                  <template slot="thead">
                    <vs-th>Name</vs-th>
                    <vs-th>Comment</vs-th>
                  </template>
                  <template>
                    <vs-tr :key="index" v-for="(tr, index) in orderDetails.ccp_items">

                      <vs-td>
                        {{tr.name}}
                      </vs-td>

                      <vs-td>
                        {{tr.comment}}
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
      </vx-card-custom>
      <vx-card-custom v-if="orderDetails.sundry_items.length > 0" style="border-radius: 0"
                      :noShadow="true" title="Sundry items">
        <vs-table :hoverFlat="true"  noDataText="" class="table-dark-inverted table-auto vs-con-loading__container">

                  <template slot="thead">
                    <vs-th>Batch Number</vs-th>
                    <vs-th>Quantity</vs-th>
                  </template>
                  <template>
                    <vs-tr :key="index" v-for="(tr, index) in orderDetails.sundry_items">

                      <vs-td>
                        {{tr.batch_no}}
                      </vs-td>

                      <vs-td>
                        {{tr.quantity}}
                      </vs-td>

                    </vs-tr>
                  </template>
        </vs-table>
      </vx-card-custom>
    </page>
  </span>
</template>

<script>
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import {work_order_statuses} from '@/constants/statuses'
  import ConfirmWorkOrderPopUp from "@/components/popups/manufacturing/work-order/ConfirmWorkOrderPopUp";
  import AddQcTestWorkOrderPopUp from "@/components/popups/manufacturing/work-order/qc-tests/AddQcTestWorkOrderPopUp";
  import moment from 'moment'
  import axios from "@/axios";

  export default {
    name: "WorkOrderView",
    data() {
      return {
        orderDetails: {
          id: '',
          production_line_id: {},
          work_order_code: '',
          formulation_code: '',
          formulation_name: '',
          work_order_date: '',
          start_time: '',
          end_time: '',
          required_by: '',
          order_items: [],
          unallocated_amount: '',
          formulation: [],
          note: '',
          confirmed_by: '',
          status: {}
        },
        work_order_statuses: work_order_statuses,
        id: '',
        order_formulations_items: [],
        production_line_id: '',
        note: '',
        is_exceed: false,
        qc_tests: [],
        wo_formulations: [],
      }
    },
    components: {
      flatPickr,
      ConfirmWorkOrderPopUp,
      AddQcTestWorkOrderPopUp,
    },
    mixins: [SuccessMessage, ErrorMessages],
    async mounted() {
      this.id = this.$route.params.id;
      await this.fetchWoPdf()
      await this.getWorkOrderDetails()
      this.$emit('setAppClasses', 'print-view')
    },
    methods: {
      async refreshData() {
        await this.getWorkOrderDetails()
      },
      async fetchWoPdf() {
        try {
          const response = await axios.get(`/admin/manufacture/work_order/${this.id}/pdf`, { responseType: 'blob' });
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(blob);
          window.location.href = fileURL;
          window.focus();
        } catch (error) {
          
        }
      },
      async getWorkOrderDetails() {
        await this.$vs.loading();
        try {
          const {data} = (await ManufacturingRepository.getWorkOrder(this.id)).data;
          this.orderDetails = data;
          this.orderDetails.end_time = this.__utcToLocalTime(this.orderDetails.end_time)
          this.orderDetails.start_time = this.__utcToLocalTime(this.orderDetails.start_time)
          this.orderDetails.actual_end_time = this.__utcToLocalTime(this.orderDetails.actual_end_time)
          this.orderDetails.actual_start_time = this.__utcToLocalTime(this.orderDetails.actual_start_time)
          this.orderDetails.order_items = data.order_items.map((n) => {
            n.pending_manufacture_quantity = Number(n.pending_manufacture_quantity)
            n.quantity = Number(n.quantity)
            n.max = Number(n.quantity) + Number(n.pending_manufacture_quantity)
            return n
          })
          if(this.orderDetails.formulation_formulation.length > 0) {
            this.orderDetails.formulation_raw_material = this.orderDetails.formulation_raw_material.concat(this.orderDetails.formulation_formulation)
          }
          this.orderDetails.formulation = this.orderDetails.formulation_raw_material.sort((a, b) => {
            if (a.manufacture_order < b.manufacture_order) return -1
            return a.manufacture_order > b.manufacture_order ? 1 : 0
          })
          this.wo_formulations = []
          this.orderDetails.formulation.forEach((x) => {
            const items = x.assigned_raw_material.length === 0 ? x.location : x.assigned_raw_material
            x.row_type = 'main'
            this.wo_formulations.push(x)
            this.wo_formulations.push({ row_type: 'sub', items: items })
          })
          await this.getWorkOrderQcTest()
        } catch (e) {

        }
        this.$vs.loading.close()

      },
      async getWorkOrderQcTest() {
        const {data} = (await ManufacturingRepository.getWorkOrderQcTest(this.id)).data;
        this.qc_tests= data
      },
      async onClickLink(id) {
          this.$router.push({path: `/pages/product-orders/${id}`})
      },

      async onClickSubmit() {
        await this.$vs.loading({
          container: '#work-order-right-section',
          scale: 0.45
        });
        try {
          const formulation_order_item_ids =  this.orderDetails.order_items.map((n) => {
              if (Number(n.quantity) > 0) {
              return {id: n.id, quantity: n.quantity}
              }
          }).filter((n) => {
              return n !== undefined;
          })

          let payload = {
            production_line_id: this.orderDetails.production_line_id.id,
            formulation_order_item_ids,
            note: this.note
          };
          await ManufacturingRepository.updateWorkOrder(this.id, payload);
          this.showSuccessMessage('Work order updated successfully');
          this.$router.push({path: `/pages/manufacturing/work-orders`})
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#work-order-right-section > .con-vs-loading')

      },
      onInputQty() {
        const production_line_total_quantity = this.orderDetails.production_line_id.max_capacity_kg
        const total_selected_item_quantity = this.orderDetails.order_items.filter((m) => !!m.quantity).reduce(function(acc, val) { return acc + Number(val.quantity); }, 0)
        if(Number(total_selected_item_quantity) > Number(production_line_total_quantity)) {
          this.is_exceed = true
        } else {
          this.is_exceed = false
        }
      },
      async onClickTimeSubmit() {
        await this.$vs.loading({
          container: '#work-order-date-section',
          scale: 0.45
        });
        try {
          const payload = {
            work_order_date: this.orderDetails.work_order_date,
            start_time: moment(this.orderDetails.start_time, 'HH:mm').utc().format('HH:mm'),
            production_line_id: this.orderDetails.production_line_id.id
          }
          await ManufacturingRepository.updateWorkOrderDateTime(this.id, payload);
          this.showSuccessMessage('Work order updated successfully');
          await this.getWorkOrderDetails()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#work-order-date-section > .con-vs-loading')
      },
      workOrderColorFactory() {
        const color  = this.work_order_statuses.find((n) => n.id === this.orderDetails.status.id)
        return color ? color.color : 'dark'
      },
      async onClickStatusChange(url) {
        if (url === 'confirm') {
          this.$refs.confirmWorkOrderPopUp.openPopup(this.orderDetails.id, this.orderDetails.production_line_id.id)
        } else {
          await this.$vs.loading({
            container: '#work-order-date-section',
            scale: 0.45
          });
          try {
            await ManufacturingRepository.workOrderStatusChange(this.orderDetails.id, url, {})
            this.showSuccessMessage('Work order status changed successfully')
            await this.refreshData()
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close('#work-order-date-section > .con-vs-loading')
        }

      },
      toFixed(number) {
        return Number(number).toFixed(2)
      },
      onClickCreateQcTest(method, data = {}) {
        this.$refs.addQcTestWorkOrderPopUp.openPopup(this.id, this.orderDetails.formulation_type, method, data, this.orderDetails.formulation_id)
      },
      async onClickViewWorkOrderOnTimeline() {
        this.$router.push({path: `/pages/manufacturing/manufacturing-timeline?wo=${this.orderDetails.id}`})
      },
      onClickPrint() {
        window.print()
      }
    },
    computed: {
      totalSelectedQuantityKilo() {
        const total = this.orderDetails.order_items.reduce(function (acc, val) {
          return acc + Number(val.quantity);
        }, 0);
        return total.toFixed(2)
      },
      totalQuantityToManufacture() {
        const total = Number(this.totalSelectedQuantityKilo) + Number(this.orderDetails.unallocated_amount)
        return Number(total).toFixed(2)
      },
      totalReBlendQuantity() {
        const total = this.orderDetails.reblended_stock.reduce(function (acc, val) {
          return acc + Number(val.completed_quantity);
        }, 0);
        return total.toFixed(2)
      },
      totalRmQuantityKilo() {
        const total = this.orderDetails.formulation.reduce(function (acc, val) {
          return acc + Number(val.quantity_kg);
        }, 0);
        return total.toFixed(2)
      },
      totalRmQuantityLiter() {
        const total = this.orderDetails.formulation.reduce(function (acc, val) {
          return acc + Number(val.quantity_lt);
        }, 0);
        return total.toFixed(2)
      },
    }
  }
</script>

<style lang="scss">
page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

@media print {
  .print-view {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #printDiv,
    #printDiv * {
      visibility: visible;
    }

    #printDiv {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

.__table-heading-small {
  font-size: 10px;
}
</style>
